import React, { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
import beep from "./beep2.mp3";

const socket = io(process.env.REACT_APP_BACKEND_URL);

const NotificationListener = ({ userId }) => {
  const [notification, setNotification] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    socket.emit('join', userId);

    socket.on('transfer_notification', (data) => {
      setNotification(data);
      setIsModalOpen(true);
      triggerFeedback();
    });

    return () => {
      socket.off('transfer_notification');
    };
  }, [userId]);

  const triggerFeedback = () => {
    if (navigator.vibrate) {
      navigator.vibrate(2000);
    }

    const audio = new Audio(beep);
    audio.play().catch((err) => console.error('Error playing sound:', err));
  };

  return (
    <AnimatePresence>
      {isModalOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4 font-lora"
        >
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 bg-black/50"
            onClick={() => setIsModalOpen(false)}
          />
          
          {/* Modal */}
          <motion.div
            initial={{ y: 20, opacity: 0, scale: 0.95 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: 20, opacity: 0, scale: 0.95 }}
            transition={{ type: "spring", damping: 20, stiffness: 300 }}
            className="relative z-10 w-full max-w-xs bg-white rounded-lg shadow-xl overflow-hidden"
          >
            {/* Close button */}
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute right-2 top-2 p-1 rounded-full hover:bg-gray-100 transition-colors"
            >
              <X className="w-4 h-4 text-gray-500" />
            </button>

            {/* Content */}
            <div className="p-4 text-center">
              {/* Animated icon */}
              <motion.div
                initial={{ scale: 0.8, rotate: -10 }}
                animate={{ scale: 1, rotate: 0 }}
                transition={{ type: "spring", stiffness: 500, damping: 15 }}
                className="flex justify-center mb-3"
              >
                <CheckCircle2 className="w-10 h-10 text-green-500" strokeWidth={1.5} />
              </motion.div>

              <h3 className="text-xs font-bold text-gray-800 mb-1">
                Transfer Notification
              </h3>
              
              <p className="text-xs text-gray-600 mb-4">
                {notification?.message}
              </p>

              <button
                onClick={() => setIsModalOpen(false)}
                className="px-4 py-2 text-xs bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
              >
                Okay
              </button>
            </div>

            {/* Progress bar (optional auto-close indicator) */}
            <motion.div
              initial={{ width: '100%' }}
              animate={{ width: 0 }}
              transition={{ duration: 5, ease: 'linear' }}
              className="h-1 bg-green-400"
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default NotificationListener;